<form [formGroup]="form" class="rx-intuitive-crown-additional-fields__form">
	<rx-select
		class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell"
		[id]="controlIdPrefix + '-prep-buccal'"
		[label]="('ToothEditor.PreparationDesign' | translate) + ' - ' + ('ToothEditor.Buccal' | translate)"
		[isRequired]="preparationDesignSelectRequired"
		[isCancellable]="preparationDesignSelectCancellable"
		[formControl]="preparationDesignBuccalControl"
		[isDisabled]="preparationDesignSelectDisabled"
		[options]="preparationDesignOptions"
		(cancelSelectionEvent)="onFieldCleared('preparationDesignBuccal')"
		name="preparationDesignBuccalControl"
	></rx-select>
	<rx-select
		class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell"
		[id]="controlIdPrefix + '-prep-lingual'"
		[label]="('ToothEditor.PreparationDesign' | translate) + ' - ' + ('ToothEditor.Lingual' | translate)"
		[isRequired]="preparationDesignSelectRequired"
		[isCancellable]="preparationDesignSelectCancellable"
		[formControl]="preparationDesignLingualControl"
		[isDisabled]="preparationDesignSelectDisabled"
		[options]="preparationDesignOptions"
		(cancelSelectionEvent)="onFieldCleared('preparationDesignLingual')"
		name="preparationDesignLingualControl"
	></rx-select>

	<ng-container *ngIf="!isOtherShadeSystemSelected">
		<rx-select
			class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell rx-intuitive-crown-additional-fields__cell--shade-col"
			[id]="controlIdPrefix + '-incisal'"
			[label]="'ToothEditor.Incisal' | translate"
			[isDisabled]="shadeIncisalGingivalDisabled"
			[isCancellable]="!isReadOnly"
			[formControl]="incisalControlAsIdName"
			[options]="incisalBodyGingivalOptions"
			(cancelSelectionEvent)="onFieldCleared('incisal')"
			name="incisalControl"
		></rx-select>
	</ng-container>
	<ng-container *ngIf="isOtherShadeSystemSelected">
		<div class="rx-intuitive-crown-additional-fields__cell rx-intuitive-crown-additional-fields__cell--shade-col">
			<mat-form-field class="rx-intuitive-crown-additional-fields__mat-field" appearance="outline" subscriptSizing="dynamic">
				<mat-label>{{ 'ToothEditor.Incisal' | translate }}</mat-label>
				<input
					matInput
					[maxlength]="maxInputLengthForOtherShadeSystem"
					[formControl]="incisalControl"
					[rxIsDisabled]="shadeIncisalGingivalDisabled"
					autocomplete="off"
					name="incisalControl"
				/>
			</mat-form-field>
		</div>
	</ng-container>

	<rx-select
		class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell"
		[id]="controlIdPrefix + '-margin-buccal'"
		[label]="('ToothEditor.MarginDesign' | translate) + ' - ' + ('ToothEditor.Buccal' | translate)"
		[isRequired]="marginDesignSelectRequired"
		[isCancellable]="marginDesignSelectCancellable"
		[formControl]="marginDesignBuccalControl"
		[isDisabled]="marginDesignSelectDisabled"
		[options]="marginDesignOptions"
		(cancelSelectionEvent)="onFieldCleared('marginDesignBuccal')"
		name="marginDesignBuccalControl"
	></rx-select>
	<rx-select
		class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell"
		[id]="controlIdPrefix + '-margin-lingual'"
		[label]="('ToothEditor.MarginDesign' | translate) + ' - ' + ('ToothEditor.Lingual' | translate)"
		[isRequired]="marginDesignSelectRequired"
		[isCancellable]="marginDesignSelectCancellable"
		[formControl]="marginDesignLingualControl"
		[isDisabled]="marginDesignSelectDisabled"
		[options]="marginDesignOptions"
		(cancelSelectionEvent)="onFieldCleared('marginDesignLingual')"
		name="marginDesignLingualControl"
	></rx-select>

	<ng-container *ngIf="!isOtherShadeSystemSelected">
		<rx-select
			class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell rx-intuitive-crown-additional-fields__cell--shade-col"
			[id]="controlIdPrefix + '-gingival'"
			[label]="'ToothEditor.Gingival' | translate"
			[isDisabled]="shadeIncisalGingivalDisabled"
			[isCancellable]="!isReadOnly"
			[formControl]="gingivalControlAsIdName"
			[options]="incisalBodyGingivalOptions"
			(cancelSelectionEvent)="onFieldCleared('gingival')"
			name="gingivalControl"
		></rx-select>
	</ng-container>
	<ng-container *ngIf="isOtherShadeSystemSelected">
		<div class="rx-intuitive-crown-additional-fields__cell rx-intuitive-crown-additional-fields__cell--shade-col">
			<mat-form-field class="rx-intuitive-crown-additional-fields__mat-field" appearance="outline" subscriptSizing="dynamic">
				<mat-label>{{ 'ToothEditor.Gingival' | translate }}</mat-label>
				<input
					matInput
					[maxlength]="maxInputLengthForOtherShadeSystem"
					[formControl]="gingivalControl"
					[rxIsDisabled]="shadeIncisalGingivalDisabled"
					autocomplete="off"
					name="gingivalControl"
				/>
			</mat-form-field>
		</div>
	</ng-container>

	<rx-select
		class="rx-intuitive-crown-additional-fields__field rx-intuitive-crown-additional-fields__cell rx-intuitive-crown-additional-fields__cell--stump"
		[id]="controlIdPrefix + '-stump-shade'"
		[label]="'ToothEditor.StumpShade' | translate"
		[isRequired]="stumpShadeSelectRequired"
		[isCancellable]="stumpShadeSelectCancellable"
		[isDisabled]="stumpShadeSelectDisabled"
		[formControl]="stumpShadeControl"
		[options]="stumpShadeOptions"
		(cancelSelectionEvent)="onFieldCleared('stumpShade')"
		name="stumpShadeControl"
	></rx-select>
</form>
